import { render, staticRenderFns } from "./BpcFormCreateResource.vue?vue&type=template&id=51649424&"
import script from "./BpcFormCreateResource.vue?vue&type=script&lang=js&"
export * from "./BpcFormCreateResource.vue?vue&type=script&lang=js&"
import style0 from "./BpcFormCreateResource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports